import axios from 'axios';
import { ICategory } from '../interface/ICategory';
import store from './Store';

export default class CategoryDataStore {

    private static _instance: CategoryDataStore;

    private _yearData: ICategory[] = [];
    private _serverData: ICategory[] = [];

    public static get instance() {
        return this._instance || (this._instance = new this())
    }

    public get yearData(){
        return this._yearData;
    }

    public get serverData(){
        return this._serverData;
    }

    public async getData() {
        try {
            const config = store.CommonDataStore.config;

            const paramDataY = {
                productId: config.productId,
                country: config.country,
                categoryType: 1,
            }

            const apicallList = [axios.get(`${config.apiUrl}/category`,{params: paramDataY})];

            if (store.CommonDataStore.config.useCategorySelect) {
                let paramDataC = {
                    productId: config.productId,
                    country: config.country,
                    categoryType: 0
                }
                paramDataC = (config.categorySort)? {...paramDataC, ...{sort: config.categorySort}} : { ...paramDataC, ...{ sort: 'asc' } };
                apicallList.push(axios.get(`${config.apiUrl}/category`,{params: paramDataC}));
            }

            const res = await axios.all(apicallList);

            this._yearData = res[0].data;
            this._serverData = res[1]?.data;
        } catch (e) {
            console.log(e);
        }
    }



} // end of class